import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../ng-material/ng-material.module';

// Components
import { LoaderComponent } from './loader/loader.component';
import { DragDropDirective } from './directives/drag-drop.directive';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { LatlongInputComponent } from './latlong-input/latlong-input.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';


@NgModule({
  declarations: [
    LoaderComponent,
    DragDropDirective,
    MultiSelectComponent,
    LatlongInputComponent,
    ConfirmDialogComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  exports:[
    LoaderComponent,
    DragDropDirective,
    MultiSelectComponent,
    LatlongInputComponent,
    ConfirmDialogComponent
  ],
})
export class SharedModule { }
